import axios from 'axios';
import type { HttpResponse } from '@/api/interceptor';

export interface DocumentTitle {
  zh_cn: string;
  en_us: string;
}

export interface DocumentContent {
  zh_cn: string;
  en_us: string;
}

export interface ConsoleDocumentListItem {
  version?: string;
  rank: number;
  title: DocumentTitle;
  doc_id: number;
  version_created_at: number;
  created_at: string;
  is_dir: boolean;
  children?: ConsoleDocumentListItem[];
}
export interface ConsoleDocumentDetail {
  doc: {
    parent_id: number;
    doc_id: number;
    version_num: string;
    rank: number;
    title: DocumentTitle;
    content: DocumentContent;
    version_created_at: number;
    is_dir: boolean;
    created_at: string;
  };
}

/**
 * 查询文档列表
 * /api/console/doc/v1/list
 */
export const listConsoleDocumentsApi = () => {
  return axios.post<any, HttpResponse<{ results: ConsoleDocumentListItem[] }>>(
    '/api/console/doc/v1/list'
  );
};

/**
 * 查询文档
 * /api/console/doc/v1/get
 * @param doc_id 文档ID
 */
export const getConsoleDocumentApi = (data: { doc_id: number }) => {
  return axios.post<any, HttpResponse<ConsoleDocumentDetail>>(
    '/api/console/doc/v1/get',
    data
  );
};

export default {
  listConsoleDocumentsApi,
  getConsoleDocumentApi,
};
